"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackClubPromotionBannerClick = void 0;
const enums_1 = require("../enums");
const trackAnalyticsEvent_1 = require("./trackAnalyticsEvent");
function trackClubPromotionBannerClick(clickElement, clickText, clickUrl) {
    (0, trackAnalyticsEvent_1.trackAnalyticsEvent)({
        eventData: {
            eventName: enums_1.GA4EventName.ClickButton,
            feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
            click_element: clickElement,
            click_text: clickText,
            click_url: clickUrl,
        },
    });
}
exports.trackClubPromotionBannerClick = trackClubPromotionBannerClick;
//# sourceMappingURL=trackClubPromotionBannerClick.js.map